<template lang="html">
    <v-form v-model="isValid" ref="form" @submit.prevent="">
        <v-container grid-list-xs>
            <v-layout wrap>
                <v-flex xs12>
                    <v-text-field label="Nom" v-model="model.label" :rules="rules.label" required></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-select
                        label="Statut"
                        autocomplete
                        required
                        chips
                        clearable
                        :items="ProjectStatuses"
                        item-text="label"
                        item-value="value"
                        :rules="rules.status"
                        v-model="model.status"
                        >
                        <template slot="selection" slot-scope="data">
                            <v-chip>
                                {{ data.item.label }}
                            </v-chip>
                        </template>
                        <template slot="item" slot-scope="data">
                            <template v-if="typeof data.item === 'object'">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ data.item.label }}</v-list-tile-title>
                                </v-list-tile-content>
                            </template>
                        </template>
                    </v-select>
                </v-flex>
                <v-flex xs12>
                    <v-select
                        label="Gestionnaire"
                        autocomplete
                        required
                        chips
                        clearable
                        :items="users"
                        item-text="fullName"
                        item-value="id"
                        :rules="rules.user_id"
                        v-model="model.user_id"
                        >
                        <template slot="selection" slot-scope="data">
                            <v-chip>
                                <avatar size="3rem" :item="data.item"></avatar>
                                {{ data.item.first_name }} {{ data.item.last_name }}
                            </v-chip>
                        </template>
                        <template slot="item" slot-scope="data">
                            <template v-if="typeof data.item === 'object'">
                                <avatar size="3rem" :item="data.item" v-if="data.item"></avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ data.item.first_name }} {{ data.item.last_name }}</v-list-tile-title>
                                </v-list-tile-content>
                            </template>
                        </template>
                    </v-select>
                </v-flex>
                <v-flex xs12>
                    <v-select
                        v-model="super_family_id"
                        label="Super famille"
                        :items="superFamilies"
                        item-text="label"
                        item-value="id"
                        :rules="rules.super_family"
                        autocomplete
                        required
                        chips
                        clearable
                        dense
                        >
                        <template slot="selection" slot-scope="data">
                            <v-chip>
                                {{ data.item.label }}
                            </v-chip>
                        </template>
                        <template slot="item" slot-scope="data">
                            <template v-if="typeof data.item === 'object'">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ data.item.label }}</v-list-tile-title>
                                </v-list-tile-content>
                            </template>
                        </template>
                    </v-select>
                </v-flex>
                <v-flex xs12>
                    <v-select
                        v-model="family_id"
                        label="Famille"
                        :items="families"
                        item-text="label"
                        item-value="id"
                        :rules="rules.family"
                        :disabled="super_family_id == null"
                        autocomplete
                        required
                        chips
                        clearable
                        dense
                        >
                        <template slot="selection" slot-scope="data">
                            <v-chip>
                                {{ data.item.label }}
                            </v-chip>
                        </template>
                        <template slot="item" slot-scope="data">
                            <template v-if="typeof data.item === 'object'">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ data.item.label }}</v-list-tile-title>
                                </v-list-tile-content>
                            </template>
                        </template>
                    </v-select>
                </v-flex>

                <v-flex xs12>
                    <v-select
                        v-model="model.category_id"
                        label="Sous famille"
                        :items="subFamilies"
                        item-text="label"
                        item-value="id"
                        :rules="rules.category_id"
                        :disabled="family_id == null"
                        autocomplete
                        required
                        chips
                        clearable
                        dense
                        >
                        <template slot="selection" slot-scope="data">
                            <v-chip>
                                {{ data.item.label }}
                            </v-chip>
                        </template>
                        <template slot="item" slot-scope="data">
                            <template v-if="typeof data.item === 'object'">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ data.item.label }}</v-list-tile-title>
                                </v-list-tile-content>
                            </template>
                        </template>
                    </v-select>
                </v-flex>

            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    import Avatar               from '../../../components/avatar/Avatar'
    import { ProjectStatuses }  from '../../../config/enum/ProjectStatuses'

    export default {
        components: { Avatar },

        data() {
            return {
                title:    'Ajouter un projet',
                icon:     'folder',
                isValid:  false,

                model: {
                    label:        null,
                    user_id:      null,
                    status:       'market-survey',
                    category_id:  null,
                    group:        null
                },

                rules: {
                    label: [
                        (v) => !!v || 'Nom obligatoire',
                    ],
                    user_id: [
                        (v) => !!v || 'Gestionnaire obligatoire',
                    ],
                    super_family: [
                        (v) => !!v || 'Super famille obligatoire',
                    ],
                    family: [
                        (v) => !!v || 'Famille obligatoire',
                    ],
                    category_id: [
                        (v) => !!v || 'Sous famille obligatoire',
                    ]
                },

                users: [],

                categories:         [],
                super_family_id:    null,
                family_id:          null,

                ProjectStatuses
            }
        },

        computed: {
            superFamilies() {
                return this.categories.filter(c => c.parent_id == null)
            },
            families() {
                return this.categories.filter(c => c.parent_id == this.super_family_id)
            },
            subFamilies() {
                return this.categories.filter(c => c.parent_id == this.family_id)
            }
        },

        watch: {
            super_family_id(val) {
                if(val == null) {
                    this.model.group = null

                } else {
                    let code = this.categories.find(c => c.id == val).code

                    this.model.group = code == 'S1' ? 'equipment' : 'consumable'
                }
            }
        },

        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },

            onValidate() {
                if(this.$refs.form.validate()) {
                    this.axios.post('/api/projects', this.model)
                        .then(response => {
                            this.$eventHub.$emit('close-modal')
                            this.$router.push({ name: 'single-project', params: { id: response.data.id } })
                        })
                        .catch(err => console.log(err))
    			} else {
                    return false;
                    this.$eventHub.$emit('stop_loading')
                }
            },
        },

        created() {
            this.model.user_id = this.$store.state.auth.user.id;

            this.axios.get('/api/users')
                .then(response => {
                    this.users = response.data;
                    this.users.forEach(item => {
                        let obj = item
                        obj.fullName = item.first_name + ' ' + item.last_name
                        this.users.push(obj)
                    })
                })
                .catch(err => console.log(error))

            this.axios.get('/api/categories')
                .then(res   => this.categories = res.data)
                .catch(err  => console.log(err.response.data))

        }
    }
</script>


<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/views/projects/list/Create.vue